import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 1.063a1 1 0 0 0-2 0v1.31h-.472c-1.723-.006-2.689 1.409-2.732 2.688a2.64 2.64 0 0 0 .512 1.679c.389.518.97.873 1.688 1.005l.051.008.953.125v1.75H4.27a1 1 0 1 0 0 2H6v1.31a1 1 0 1 0 2 0v-1.31h.472c1.668.005 2.622-1.276 2.724-2.515.1-1.211-.596-2.565-2.193-2.858l-.05-.008L8 6.122V4.373h1.73a1 1 0 0 0 0-2H8zm-2 3.31h-.478c-.424-.002-.713.345-.727.756-.012.352.203.577.54.645L6 5.861zm2 3.766v1.488h.478c.26.001.414-.087.514-.19a.8.8 0 0 0 .21-.488.73.73 0 0 0-.11-.47c-.068-.098-.188-.204-.428-.253l.03.004-.021-.003c-.02-.004-.04-.007-.01 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const moneyCurrencyDollarPay = { render };
export {
  moneyCurrencyDollarPay as default,
  render
};
//# sourceMappingURL=money-currency-dollar-pay.svg.js.map
